// Sidebar.jsx
import React, { useRef, useEffect } from "react";
import "./Dashboard.css";

export default function UserSidebar({ menuOpen, setMenuOpen }) {
  const menuRef = useRef(null);

  // Close sidebar if clicked outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setMenuOpen]);

  return (
    <div ref={menuRef} className={`hamburger-menu ${menuOpen ? "open" : ""}`}>
      {menuOpen && (
        <div className="close-icon" onClick={() => setMenuOpen(false)}>
          ×
        </div>
      )}
      <div className="menu-header">MCV - OverSight Manager</div>
      <ul>

         <span onClick={() => (window.location.href = "/user_dashboard")}>
        <li className="nav-item">
         
            Dashboard
              </li>
          </span>
      

        {/* Compliance Dropdown */}
       <li className="nav-item has-dropdown">
  <span>Compliance</span>
  <ul className="dropdown-content">
     <li
      onClick={() => {
        localStorage.setItem("compliance_type", "data-compliance");
        window.location.href = "/manage-statutory";
      }}
    >
      Data Compliance
    </li>

    

    <li
      onClick={() => {
        localStorage.setItem("compliance_type", "custom");
        window.location.href = "/manage-self";
      }}
    >
      Contract/Custom
    </li>
    <li
      onClick={() => {
        localStorage.setItem("compliance_type", "statutory");
        window.location.href = "/manage-statutory";
      }}
    >
      Statutory
    </li>
   

   

  </ul>
</li>
 <li className="nav-item"
      onClick={() => {
        window.location.href = "/manage-data-breach";
      }}
    >
     Data Breach Management
    </li>

        {/* Reports Dropdown */}
       
<li
  className="nav-item"
  onClick={() => (window.location.href = "/comprehensive_")}
>
  Report
</li>


        {/* Assessments Dropdown 
        <li className="nav-item has-dropdown">
          <span>Assessments</span>
          <ul className="dropdown-content">
            <li className="sub-dropdown">
              <span>DPDPA</span>
              <ul className="sub-dropdown-content">
                <li onClick={() => (window.location.href = "/DPDPA_test")}>Start</li>
                <li onClick={() => (window.location.href = "/DPDPA-view")}>View</li>
              </ul>
            </li>
            <li className="sub-dropdown">
              <span>DPDP Act</span>
              <ul className="sub-dropdown-content">
                <li onClick={() => (window.location.href = "/DPDP-start")}>Start</li>
                <li onClick={() => (window.location.href = "/DPDP-view")}>View</li>
              </ul>
            </li>
          </ul>
        </li>*/}

        {/* General Dropdown */}
        
        <li className="nav-item has-dropdown">
          <span>General</span>
          <ul className="dropdown-content">
            <li onClick={() => (window.location.href = "/outofoffice")}>Out of Office</li>
            <li onClick={() => (window.location.href = "/tns")}>Terms & Services</li>
           {/*} <li onClick={() => (window.location.href = "/settings_")}>Settings</li>*/}
          </ul>
        </li>
      </ul>
    </div>
  );
}
